import {
  Button,
  Collapse,
  List,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
} from "@mui/material";
import { useEffect, useState } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import EditIcon from "@mui/icons-material/Edit";
import { Box } from "@mui/system";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { colleaguesSelector } from "../../../store/proposalSlice";
import { canEditSelector } from "../../../store/applicantsSlice";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { setAs } from "../../../store/applicantsSlice";
import { makeStyles } from "@mui/styles";

const navigation = {
  generalInforamation: {
    proposalOverview: "/applicantsportal/generalinformation/overview",
    basics: "/applicantsportal/generalinformation/basics",
    academic: "/applicantsportal/generalinformation/academic",
    research: "/applicantsportal/generalinformation/research",
    previousEmployment: "/applicantsportal/generalinformation/prevemp",
    parallelFunding: "/applicantsportal/generalinformation/funding",
    uploadDocs: "/applicantsportal/generalinformation/upload",
    applicantdocs: "/applicantsportal/generalinformation/applicantdocs",
  },
  projectFinancing: {
    salaries: "/applicantsportal/projectfinancing/Personnel",
    travel: "/applicantsportal/projectfinancing/travel",
  },
  projectSchedules: "/applicantsportal/projectSchedules/",
  miscellaneous: "/applicantsportal/miscellaneous",
};

const routeMap = {
  new_proposaltitle: {
    route: navigation.generalInforamation.proposalOverview,
    field: "title",
  },
  new_researchareaid: {
    route: navigation.generalInforamation.proposalOverview,
    field: "researchAreaId",
  },
  new_researchsubareaid: {
    route: navigation.generalInforamation.proposalOverview,
    field: "researchSubAreaId",
  },
  new_numberofyears: {
    route: navigation.generalInforamation.proposalOverview,
    field: "numberOfYear",
  },
  new_researchareadescription: {
    route: navigation.generalInforamation.proposalOverview,
    field: "researchAreaDescription",
  },
  new_keywords: {
    route: navigation.generalInforamation.proposalOverview,
    field: "keyWord",
  },
  // reviewers: {
  //   label: "Reviewers",
  //   route: navigation.miscellaneous,
  // },
  new_title: {
    route: navigation.generalInforamation.basics,
    field: "title",
  },
  firstname: {
    route: navigation.generalInforamation.basics,
    field: "first_name",
  },
  lastname: {
    route: navigation.generalInforamation.basics,
    field: "last-name",
  },
  parentcustomerid: {
    route: navigation.generalInforamation.basics,
    field: "institution_name",
  },
  new_faculty: {
    route: navigation.generalInforamation.basics,
    field: "faculty_name",
  },
  department: {
    route: navigation.generalInforamation.basics,
    field: "department_name",
  },
  emailaddress1: {
    route: navigation.generalInforamation.basics,
    field: "institution_city",
  },
  mobilephone: {
    route: navigation.generalInforamation.basics,
    field: "primary_email",
  },
  // emailaddress2: {
  //   label: "Secondary Email",
  //   route: navigation.generalInforamation.basics,
  //   field: "secondary_email",
  // },
  address1_city: {
    route: navigation.generalInforamation.basics,
  },
  // telephone3: {
  //   label: "Office Phone",
  //   route: navigation.generalInforamation.basics,
  //   field: "office_phone",
  // },
  majorresearchinterest: {
    route: navigation.generalInforamation.research,
  },
  parallelFunding: {
    route: navigation.generalInforamation.parallelFunding,
  },
  academicBackground: {
    route: navigation.generalInforamation.academic,
  },
  previousEmployment: {
    route: navigation.generalInforamation.previousEmployment,
  },
  timeSchedule: {
    route: navigation.projectSchedules,
  },
  // budget: {
  //   label: "Financing",
  //   route: navigation.projectFinancing,
  // },
  salariesBudget: {
    route: navigation.projectFinancing.salaries,
  },
  travelBudget: {
    route: navigation.projectFinancing.travel,
  },
  abstractFiles: {
    route: navigation.generalInforamation.uploadDocs,
  },
  shortDescriptionFiles: {
    route: navigation.generalInforamation.uploadDocs,
  },
  briefBiosFiles: {
    route: navigation.generalInforamation.applicantdocs,
  },
  publicationListFiles: {
    route: navigation.generalInforamation.uploadDocs,
  },
  budgetFiles: {
    route: navigation.generalInforamation.uploadDocs,
  },
  fullProjectDescriptionFiles: {
    route: navigation.generalInforamation.uploadDocs,
  },
  bibliography: {
    route: navigation.generalInforamation.uploadDocs,
  },
  publicationFiles: {
    route: navigation.generalInforamation.applicantdocs,
  },
  diplomaFiles: {
    route: navigation.generalInforamation.uploadDocs,
  },
};
const useStyles = makeStyles((theme) => ({
  editButton: {
    "&:hover": {
      backgroundColor: theme.palette.gif.yellow.hover,
    },
    color: theme.palette.gif.yellow.dark,
    backgroundColor: theme.palette.gif.yellow.color,
  },
  expand: {
    "&:hover": {
      backgroundColor: theme.palette.gif.blue.hover,
    },
    color: theme.palette.gif.blue.color,
    backgroundColor: theme.palette.gif.blue.background,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
}));

export default function SubmitGroup(props) {
  const { group } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const canEdit = useSelector(canEditSelector);
  const applicants = useSelector(colleaguesSelector);
  const [errors, setErrors] = useState([]);
  const [openGroups, setOpenGroups] = useState({});

  const handleGroupClick = (groupid) => {
    setOpenGroups((prev) => ({ ...prev, [groupid]: !prev[groupid] }));
  };

  const gotoError = (error, groupid) => {
    const me = applicants.find((a) => a.id === groupid);
    if (Boolean(me?.email)) dispatch(setAs(me.email));
    const base = error.route;
    if (!Boolean(error.field)) history.push(base);
    history.push(`${base}?focus=${error.field}`);
  };

  useEffect(() => {
    const allErrors = group.validations.filter((v) => !v.isValid);
    allErrors.forEach((error) => {
      error.route = routeMap[error.name]?.route;
      error.field = routeMap[error.name]?.field;
    });
    setErrors(allErrors);
  }, [group]);

  return (
    <>
      {errors.length > 0 ? (
        <Box key={group.id}>
          <ListItem button onClick={() => handleGroupClick(group.id)}>
            <ListItemText primary={group.name || "Proposal"} />
            <ListItemIcon />
            {Boolean(openGroups[group.id]) ? (
              <Button
                disableElevation
                variant="contained"
                size="small"
                className={classes.expand}
                startIcon={<ExpandLess />}
              >
                Hide missing informtaion
              </Button>
            ) : (
              <Button
                disableElevation
                variant="contained"
                size="small"
                className={classes.expand}
                startIcon={<ExpandMore />}
              >
                Show missing informtaion
              </Button>
            )}
          </ListItem>
          <Collapse
            in={Boolean(openGroups[group.id])}
            timeout="auto"
            unmountOnExit
          >
            <List component="div" disablePadding>
              {errors.map((error, index) => (
                <ListItem
                  key={`${group.id}-${index}`}
                  className={classes.nested}
                >
                  <ListItemText primary={error.errorMessage} />
                  {error.route && canEdit && (
                    <ListItemSecondaryAction>
                      <Button
                        disableElevation
                        variant="contained"
                        size="small"
                        className={classes.editButton}
                        startIcon={<EditIcon />}
                        onClick={() => gotoError(error, group.id)}
                      >
                        Edit
                      </Button>
                    </ListItemSecondaryAction>
                  )}
                </ListItem>
              ))}
            </List>
          </Collapse>
        </Box>
      ) : (
        <ListItem button key={group.id}>
          <ListItemText primary={group.name || "Proposal"} />
          <ListItemIcon>
            <CheckCircleIcon style={{ color: "#00A14B" }} />
          </ListItemIcon>
        </ListItem>
      )}
    </>
  );
}
